{
  "route.tiers.title": "会員層および会員特典",
  "benefits.deleteBenefit.deleteDialog.header": "この会員特典を削除してもよろしいですか?",
  "benefits.deleteBenefit.deleteDialog.content": "この会員特典を削除すると、会員層メンバーはこの特典を受けられなくなります。",
  "benefits.deleteBenefit.alertDialog.header": "この会員特典は削除できません。",
  "benefits.deleteBenefit.alertDialog.content": "この会員特典は、まだ特典を利用していないメンバーに関連付けられています。会員特典バンドルからこの会員特典の選択を解除してみてください。",
  "benefits.deleteBenefit.failureAlert": "この会員特典の削除中に問題が発生しました。",
  "benefits.purchaseBenefits.text": "{pointsText} = {currencySymbol}{pointsSpent} 利用",
  "benefits.pointsFromPurchases": "購入で {pointsPlaceHolder}",
  "benefits.pointsCatalogBenefitData": "追加で {pointsPlaceHolder}",
  "benefits.createNew.button.tooltip": "会員特典を編集して再開するには、\"次のバージョンの編集\" を選択する必要があります。",
  "benefits.createNew.button.label": "会員特典の作成",
  "benefits.header.title.regular": "固定の会員特典を作成し、会員層に割り当てます。会員層設定でポイントと購入要件を定義できます。",
  "benefits.header.title.additional": "ロイヤリティメンバーに提供する追加会員特典を作成します。追加会員特典の管理と割り当ては、ロイヤリティ API を使用して行うことができます。",
  "benefits.header.title.fixedBenefits.learnMoreLinkText": "詳細はこちら",
  "benefits.header.title.fixedBenefits": "固定会員特典を作成し、会員層に割り当てます。会員層設定でポイントと購入要件を定義できます。{learnMoreLink}。",
  "benefits.header.title.additionalBenefits.learnMoreLinkText": "詳細はこちら",
  "benefits.header.title.additionalBenefits": "ロイヤリティメンバーに提供する追加会員特典を作成します。追加会員特典の管理と割り当ては、ロイヤリティ API またはメンバープロファイルを使用して行うことができます。{learnMoreLink}。",
  "benefitDefaultData.singleCurrencyText.points": "{symbol}1 利用ごとに 1 ポイント獲得",
  "tiers.header.title.learnMoreLinkText": "詳細はこちら",
  "tiers.header.title": "会員層を作成し、編集します。プランを開始した後は、会員層は追加のみ可能で、削除することはできなくなります。{learnMoreLink}。",
  "tiers.editIcon.tooltip": "この会員層を編集するには、前の会員層の設定を完了する必要があります。",
  "tiers.reviewIcon.tooltip": "会員層設定を表示",
  "tiers.status.inactive.tooltip": "この会員層の設定を完了する必要があります。",
  "tiers.cardSubtitle.points.text.invitationOnly": "招待者専用会員層",
  "tiers.cardSubtitle.points.text.pointsUnderMax": "{points} - {maxPoints} {pointsText} 獲得 (年間)",
  "tiers.cardSubtitle.points.text.pointsAtMax": "{points}+ {pointsText} 獲得 (年間)",
  "tiers.cardSubtitle.purchasesRequired.plural.zero": "",
  "tiers.cardSubtitle.purchasesRequired.plural.one": "{number} 件の購入が必要",
  "tiers.cardSubtitle.purchasesRequired.plural.two": "{number} 件の購入が必要",
  "tiers.cardSubtitle.purchasesRequired.plural.few": "{number} 件の購入が必要",
  "tiers.cardSubtitle.purchasesRequired.plural.many": "{number} 件の購入が必要",
  "tiers.cardSubtitle.purchasesRequired.plural.other": "{number} 件の購入が必要",
  "tiers.deleteTierDialog.headline": "この会員層を削除してもよろしいですか?",
  "tiers.deleteTierDialog.content": "この会員層を削除すると、会員層メンバーは下位の会員層に移行し、現在の会員層特典を受けられなくなります。",
  "tiers.addNewCard.tooltip.invalid": "この会員層を作成するには、前の会員層の設定を完了する必要があります。",
  "tiers.addNewCard.text": "会員層の作成",
  "tierSetup.deleteCatalogBenefitDialog.headline": "この会員特典を削除してもよろしいですか?",
  "tierSetup.deleteCatalogBenefitDialog.content": "この会員特典を削除すると、会員層メンバーはこの特典を受けられなくなります。",
  "tierSetup.title.new": "会員層の作成",
  "tierSetup.title.edit": "会員層の設定 -{name}",
  "benefitSetup.title.new": "会員特典の作成",
  "benefitSetup.title.edit": "会員特典の編集",
  "benefitSetup.type.title": "会員特典タイプの選択",
  "benefitSetup.benefitName.title": "会員特典名",
  "benefitSetup.benefitName.tooltip": "メンバーに表示される会員特典名を入力します。",
  "benefitSetup.targetMarkets.label": "マーケットの選択",
  "benefitSetup.targetMarkets.tooltip": "この会員特典の対象マーケットを選択します。選択したマーケットに対して特典プールが設定されていることを確認してください。",
  "benefitSetup.notification": "イベントを固定会員特典として設定するには、まずイベントアクションを作成する必要があります。選択したアクションで、この会員特典に対してさまざまな会員層向け特典を定義できます。イベント固定会員特典は自動化センタプログラムによってトリガされます。",
  "benefitSetupCustomFields.custom.label": "カスタム特典",
  "benefitSetupCustomFields.custom.tooltip": "メンバーに表示される特典名です。特典の受け取り方法は自由に決定できます。",
  "benefitSetupEventFields.eventActionId.label": "アクションを選択",
  "benefitSetupEventFields.eventActionId.placeholder": "-- アクションを選択 --",
  "benefitSetupEventFields.tiersAndRewards.title": "会員層と特典",
  "benefitSetupEventFields.tiersAndRewards.tooltip": "選択したアクションに対して会員層と特典を定義できます。特典は、この会員層の固定会員特典の表に示されます。",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.label": "アクセスを選択",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.placeholder": "-- アクセスを選択 --",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.tooltip": "会員層ごとに有効なアクセスを選択してください。",
  "benefitSetupVoucherFields.rewardId.label": "バウチャープールを選択",
  "benefitSetupVoucherFields.rewardId.placeholder": "-- バウチャープールを選択 --",
  "benefitSetupVoucherFields.rewardId.tooltip": "この会員特典の特典はバウチャーと引き換えられます。会員層ごとに有効なバウチャープールを選択してください。",
  "benefitSetupVoucherFields.tiersAndRewards.title": "会員層と特典プールの選択",
  "benefitSetupVoucherFields.tiersAndRewards.tooltip": "この会員特典の特典はバウチャーを通して引き換えられます。会員層ごとに有効なバウチャープールを選択してください。",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.title": "会員層とアクセスの選択",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.tooltip": "この会員特典の特典はアクセスと引き換えられます。会員層ごとに有効なアクセスを選択してください。",
  "tierSetupGeneral.tierValueInPointsTooltip.spend": "この会員層に入るために必要な最低クレジット額を定義します。",
  "tierSetupGeneral.tierValueInPointsTooltip.points": "この会員層に入るために必要な最低ポイント数を定義します。",
  "tierSetupGeneral.tierValueInPointsTooltip.other": "最初の会員層はエントリー層で、ロイヤリティメンバーであれば誰でも無条件で入ることができます。",
  "tierSetupGeneral.numberOfPurchasesTooltip.pointsOrSpend": "この会員層に入るために必要な最低購入額を定義します。この要件は任意で、ポイント要件に加えて設定することもできます。",
  "tierSetupGeneral.title": "一般設定",
  "tierSetupGeneral.tierType.label": "会員層タイプ",
  "tierSetupGeneral.inviteTier.notification": "支払いと招待の管理、会員層へのメンバーの追加を行うには、ロイヤリティ API を呼び出すか、メンバープロファイルで手動で設定します。獲得ポイントはプラン設定に基づいて自動的に計算されます。API またはメンバープロファイルで、会員層から外れたメンバーに対するアクションを定義することもできます。",
  "tierSetupGeneral.tierName.label": "会員層名",
  "tierSetupGeneral.tierName.tooltip": "メンバーに表示される会員層名を入力します。この名前は、パーソナライゼーションサービスのロイヤリティトークンの表示にも使用されます。",
  "tierSetupGeneral.tierIcon.label": "会員層アイコン",
  "tierSetupGeneral.tierIcon.tooltip": "メンバーに表示されるアイコンを選択します。このアイコンは、パーソナライゼーションサービスのロイヤリティトークンの表示にも使用されます。",
  "tierSetupGeneral.tierIcon.iconText": "会員層に追加",
  "tierSetupGeneral.requirements.title": "必要条件",
  "tierSetupGeneral.tierPoints.label.points": "会員層の価値 (ポイント数)",
  "tierSetupGeneral.tierPoints.label.spend": "会員層に必要な総クレジット数",
  "tierSetupGeneral.tierPoints.postfixLabel.points": "ポイント",
  "tierSetupGeneral.tierPoints.postfixLabel.loyalty": "ポイント",
  "tierSetupGeneral.tierPoints.postfixLabel.status": "ステータスポイント",
  "tierSetupGeneral.tierPoints.postfixLabel.balance": "利用ポイント",
  "tierSetupGeneral.tierPurchases.label": "会員層に必要な購入数",
  "tierSetupGeneral.tierPurchases.postfixLabel": "回",
  "tierSetupGeneral.calculation.tierDropout.label": "会員層計算",
  "tierSetupGeneral.calculation.tierDropout.tooltip": "この会員層を会員層計算に含めるか、会員層計算を行わない (ランクダウンなし) かを選択します。",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.label": "会員層有効期限",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.tooltip": "この会員層の有効期限を他の会員層と異なる期限にして再計算するには、この設定を変更します。",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.postfixLabel": "年",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.label": "会員層有効期限",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.tooltip": "この会員層の有効期限を他の会員層と異なる期限にして再計算するには、この設定を変更します。",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.postfixLabel": "カ月",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.equal": "1 {symbol} 利用につき、1 クレジット付与",
  "tierSetupPurchaseBenefits.catalogSelector.label": "ブランドとカテゴリを選択",
  "tierSetupPurchaseBenefits.catalogSelector.placeholder": "プロモーションする特定のブランドまたはカテゴリを選択します。",
  "tierSetupPurchaseBenefits.catalogSelector.disabledItemsTooltip": "このカテゴリ/ブランドは前の会員特典ですでに選択されています。",
  "tierSetupPurchaseBenefits.benefitMessageHeader.title": "会員特典メッセージ",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltipText": "メッセージフォーマットを表示",
  "tierSetupPurchaseBenefits.benefitMessageTitle.label": "タイトル",
  "tierSetupPurchaseBenefits.benefitMessageTitle.placeholder": "会員特典メッセージのタイトルを入力します。",
  "tierSetupPurchaseBenefits.benefitMessageText.label": "本文",
  "tierSetupPurchaseBenefits.benefitMessageText.placeholder": "会員特典メッセージの本文を入力します。",
  "tierSetupPurchaseBenefits.benefitMessageText.tooltip": "メンバーに表示されるポイントと通貨値は、ウェブサイトで選択された通貨によって異なります。",
  "tierSetupPurchaseBenefits.benefitIcon.label": "会員特典アイコン",
  "tierSetupPurchaseBenefits.benefitIcon.selectIconText": "会員特典に追加",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.selectedItems": "特定のブランド、カテゴリ、アクションに対してのみクレジットを付与",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.first": "特定のブランドまたは商品カテゴリの購入に対して、通常とは異なるポイント値を設定できます。設定したポイントは、通常の購入ポイントに追加されるのではなく、その代わりとして付与されます。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.other": "商品が異なるポイント値を持つ複数のカテゴリに属している場合、その中で最も高い値が付与されます。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.first": "特定のブランドまたはカテゴリの購入に対して、通常とは異なるクレジットレートを設定できます。設定したクレジットレートは、購入のクレジット残高の更新時に標準レートの代わりに適用されるようになります。",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.other": "商品が異なるレート値を持つ複数のカテゴリに属している場合、その中で最も高い値が付与されます。",
  "tierSetupPurchaseBenefits.notification": "ポイントは、ロイヤリティプログラムにおける通貨としてすべてのメンバーに適用されます。異なる通貨間でもポイントの価値が統一されるように設定してください。",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.zero": "最小 {number} ポイント必要です",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.one": "最小 {number} ポイント必要です",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.two": "最小 {number} ポイント必要です",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.few": "最小 {number} ポイント必要です",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.many": "最小 {number} ポイント必要です",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.other": "最小 {number} ポイント必要です",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.zero": "最小 {number} クレジット必要です",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.one": "最小 {number} クレジット必要です",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.two": "最小 {number} クレジット必要です",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.few": "最小 {number} クレジット必要です",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.many": "最小 {number} クレジット必要です",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.other": "最小 {number} クレジット必要です",
  "tierSetupPurchaseBenefits.pointsType.title": "会員層ポイントタイプ",
  "tierSetupPurchaseBenefits.pointsType.label": "ポイントタイプ",
  "tierSetupPurchaseBenefits.pointsType.tooltip": "会員層にいる間にメンバーに付与されるポイントの種別を定義します。",
  "tierSetupPurchaseBenefits.pointsType.error": "ポイントタイプがポイント乗算のアクション定義と競合しています。アクション {actions} を修正して、再度お試しください。",
  "tierSetupPurchaseBenefits.pointsType.options.loyalty": "ポイント (ステータスポイントと利用ポイント両方)",
  "tierSetupPurchaseBenefits.pointsType.options.status": "ステータスポイントのみ",
  "tierSetupPurchaseBenefits.pointsType.options.spend": "利用ポイントのみ",
  "tierSetupPurchaseBenefits.header.points": "購入時のポイント付与",
  "tierSetupPurchaseBenefits.header.spend": "購入時のロイヤリティクレジット付与",
  "tierSetupPurchaseBenefits.header.tooltip.spend": "会員層のメンバーが購入時に獲得するクレジット額を選択します。獲得額はメンバーのロイヤリティウォレットに表示されます。",
  "tierSetupPurchaseBenefits.header.tooltip.points": "会員層のメンバーが購入時に獲得するポイント数を選択します。複数の通貨を管理している場合、通貨ごとにポイント数を設定する必要があります。購入時にポイントを付与しない場合、この設定はすべての通貨で同じです。",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltip": "この会員特典のプロモーションメッセージを入力します。このメッセージはメンバーのロイヤリティウォレットに表示されます。",
  "tierSetupPurchaseBenefits.catalogBenefit.title.points": "ブランドまたはカテゴリ別のポイント付与",
  "tierSetupPurchaseBenefits.catalogBenefit.title.spend": "ブランドまたはカテゴリ別のロイヤリティクレジット付与",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.points": "ポイント数を追加 ",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.spend": "ロイヤリティクレジット数を追加 ",
  "tierSetupVisibility.title": "表示",
  "tierSetupVisibility.tooltip": "この会員層を非表示に設定し、新規メンバーの流入を停止できます。ただし、この会員層の既存メンバーには、他の会員層に移行するまでこのこの会員層が引き続き表示されます。獲得ポイントの計算は、プラン設定に基づいて自動的に継続されます。",
  "tierSetupVisibility.visible.label": "会員層モードを選択",
  "visibility.options.visible": "表示される会員層",
  "visibility.options.invisible": "非表示の会員層",
  "multiLangPurchaseBenefitFields.alert": "すべての言語についてタイトルとテキストを入力してください。",
  "additionalBenefitsUpdateValidator.confirmed.isTrue": "必要なすべての情報を入力していることを確認してください。",
  "additionalBenefitsUpdateValidator.reason.presence": "内部追跡目的の理由を入力してください。",
  "benefitValidator.defaultConstraints.name.presence": "会員特典名を入力してください。",
  "benefitValidator.defaultConstraints.targetMarkets.presence": "マーケットを入力してください。",
  "benefitValidator.eventActionId.presence": "アクションを入力してください。",
  "benefitValidator.custom.presence": "特典の説明を入力してください。",
  "benefitValidator.tiers.atLeastOneTier": "会員層を少なくとも 1 つ選択してください。",
  "benefitValidator.rewardConstraints.rewardId.presence": "特典プールを入力してください。",
  "benefitValidator.rewardConstraints.tiers.atLeastOneTier": "会員層を少なくとも 1 つ選択してください。",
  "benefitValidator.rewardConstraints.tiers.tierId.rewardId.benefitSingleReward": "空の選択です。",
  "benefitValidator.rewardConstraints.exclusiveAccessIds.presence": "アクセスを入力してください。",
  "tiersCreationValidator.numberOfTiers.presence": "会員層の数を 1 から 10 の数字で入力してください。",
  "tiersCreationValidator.numberOfTiers.numericality.notInteger": "会員層の数を 1 から 10 の数字で入力してください。",
  "tiersCreationValidator.numberOfTiers.numericality.notLessThan": "会員層の数を 1 から 10 の数字で入力してください。",
  "tiersCreationValidator.numberOfTiers.numericality.notGreaterThan": "分布には少なくとも 2 つの会員層を入力してください。",
  "tiersCreationValidator.spend.presence": "利用金額を整数で入力してください。",
  "tiersCreationValidator.spend.numericality.notInteger": "利用金額を整数で入力してください。",
  "tiersCreationValidator.spend.numericality.notGreaterThan": "利用金額は前の会員層よりも大きい整数で入力してください。",
  "rangeTierPoints.nextTierPoints.plural.zero": "最大 {number} ポイント必要です",
  "rangeTierPoints.nextTierPoints.plural.one": "最大 {number} ポイント必要です",
  "rangeTierPoints.nextTierPoints.plural.two": "最大 {number} ポイント必要です",
  "rangeTierPoints.nextTierPoints.plural.few": "最大 {number} ポイント必要です",
  "rangeTierPoints.nextTierPoints.plural.many": "最大 {number} ポイント必要です",
  "rangeTierPoints.nextTierPoints.plural.other": "最大 {number} ポイント必要です",
  "rangeTierPoints.prevTierPoints.plural.zero": "最小 {number} ポイント必要です。",
  "rangeTierPoints.prevTierPoints.plural.one": "最小 {number} ポイント必要です。",
  "rangeTierPoints.prevTierPoints.plural.two": "最小 {number} ポイント必要です。",
  "rangeTierPoints.prevTierPoints.plural.few": "最小 {number} ポイント必要です。",
  "rangeTierPoints.prevTierPoints.plural.many": "最小 {number} ポイント必要です。",
  "rangeTierPoints.prevTierPoints.plural.other": "最小 {number} ポイント必要です。",
  "tierValidator.name.presence": "会員層名を入力してください。",
  "tierValidator.name.exclusionIgnoreCase": "この名前はすでに存在します。一意の名前を入力してください。",
  "tierValidator.nameML.multiLangField": "各言語の会員層名を入力してください。",
  "tierValidator.points.presence": "会員層の価値をポイント数で入力してください。",
  "tierValidator.pointsBenefit.titleML.multiLangField": "各言語のタイトルを入力してください。",
  "tierValidator.pointsBenefit.textML.multiLangField": "各言語の本文を入力してください。",
  "tierValidator.purchaseBenefits.pointsCatalogBenefits.purchaseBenefitCatalog": "カタログ選択を入力してください。",
  "tierValidator.pointsRates.points.presence": "ポイントを入力してください。",
  "tierValidator.pointsRates.spent.numericality.notInteger": "利用額にはゼロより大きい数値を入力してください。",
  "tierValidator.pointsRates.spent.numericality.notGreaterThan": "利用額にはゼロより大きい数値を入力してください。",
  "tierValidator.pointsRates.spent.presence": "ゼロより大きい数値を入力してください。",
  "benefitDefaultData.pointsBenefitTitle.points": "購入してポイントを獲得しよう",
  "benefitDefaultData.pointsBenefitTitle.spend": "購入してロイヤリティクレジットを獲得しよう",
  "benefitDefaultData.singleCurrencyText.spend": "購入してクレジットを獲得しよう",
  "purchasePointsToken.display": "{ x ポイント}",
  "purchasePointsToken.display.balance": "{ x ポイント利用}",
  "purchasePointsToken.display.status": "{ x ステータスポイント}",
  "purchaseCurrencyToken.display": "{ x currency }",
  "distribution.contentBox.notification": "既存の顧客ベースが各会員層にどのように振り分けられるかをプレビューします。このコンタクト分布は、最初のプランを開始する前に変更できます。",
  "distribution.contentBox.title": "会員層の作成",
  "distribution.contentBox.numberOfTiers.label": "会員層の数",
  "distribution.contentBox.calcPeriod.label": "計算期間",
  "distribution.contentBox.calcPeriod.tooltip": "コンタクト分布の計算に使用する履歴データの長さを選択します。",
  "distribution.contentBox.preview.title": "コンタクト分布のプレビュー",
  "distribution.contentBox.preview.tooltip": "コンタクトは、その会員層のすべての要件を満たす場合にのみ、該当する会員層に振り分けられます。",
  "distribution.contentBox.updateChartButton.label": "チャートの更新",
  "distribution.contentBox.chart.column.label": "顧客の数",
  "distribution.contentBox.chart.series.name": "全顧客に占める割合 (%)",
  "distribution.contentBox.singleTierSettings.tooltip.first": "最初の会員層はエントリーレベルの会員層で、ロイヤリティ顧客であれば誰でも無条件で入ることができます。",
  "distribution.contentBox.singleTierSettings.tooltip.spend": "顧客がこの会員層に入るために必要な、選択された期間における最低利用金額です。",
  "distribution.contentBox.singleTierSettings.tooltip.purchases": "顧客がこの会員層に入るために必要な、選択された期間における最低購入数です。",
  "distribution.contentBox.singleTierSettings.spend.label": "必要利用金額",
  "distribution.contentBox.singleTierSettings.purchases.label": "購入数",
  "tierSetupGeneral.tierPoints.postfixLabel.spend": "{value} 利用",
  "benefitDefaultData.pointsBenefitText.multiCurrency": "{{currencyToken}} 利用ごとに {{pointsToken}} を獲得"
}
